exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".campaign-margin___fsbj4 {\n  margin-top: -70px;\n}\n@media (max-width: 768px) {\n  .campaign-margin___fsbj4 {\n    margin-top: -50px;\n  }\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/components/charityLogo.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;CACnB;AACD;EACE;IACE,kBAAkB;GACnB;CACF","file":"charityLogo.less","sourcesContent":[".campaign-margin {\n  margin-top: -70px;\n}\n@media (max-width: 768px) {\n  .campaign-margin {\n    margin-top: -50px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"campaign-margin": "campaign-margin___fsbj4"
};